<template>
    <div>
        <div>
            <!-- Location data -->
            <div v-if="location" class="form-group pl-3">
                <h4 class="web-feedback-subtitle">Locatie</h4>
                <div class="feedback-location-icon">
                    <img
                        src="~@/assets/imported-icons/ic_fluent_location_20_regular.svg"
                        alt="feedbacklocation"
                    />
                </div>
                <div class="d-inline-block">
                    <label>{{ location.alias }}</label>
                    <span class="span-readonly">{{
                        $_getFullAddress(location.value)
                    }}</span>
                </div>
            </div>
            <!-- Melding data -->
            <h4 class="web-feedback-subtitle">Melding</h4>
            <template v-for="field in notification">
                <div
                    v-if="notification"
                    class="form-group pl-3"
                    :key="field.name"
                >
                    <!-- Meldingsnummer-->
                    <div
                        class="div-readonly"
                        v-if="
                            field.type === fieldTypeConst.GENERIC &&
                            field.name === 'meldingsnummer'
                        "
                    >
                        <label for="field.name">{{ field.alias }}</label>
                        <span id="field.name" class="span-readonly">{{
                            field.displayValue
                        }}</span>
                    </div>
                    <!-- Alphanumeric & State field -->
                    <div
                        class="div-readonly"
                        v-if="
                            field.type === fieldTypeConst.ALPHANUMERIC ||
                            field.type === fieldTypeConst.STATE
                        "
                    >
                        <label for="field.name">{{ field.alias }}</label>
                        <!-- Input field & textarea with no domain -->
                        <span
                            id="field.name"
                            class="span-readonly"
                            v-if="field.domain == null"
                            :class="{ 'readonly-scrollable': field.nrRows > 1 }"
                            >{{ field.displayValue }}</span
                        >
                        <!-- Domain -->
                        <span
                            id="field.name"
                            class="span-readonly"
                            v-if="field.domain"
                            >{{ $_getDomainDescription(field) }}</span
                        >
                    </div>
                    <!--Length & Area-->
                    <div
                        class="div-readonly"
                        v-if="
                            field.type === fieldTypeConst.GENERIC &&
                            (field.name === 'length' || field.name === 'area')
                        "
                    >
                        <label for="field.name">{{ field.alias }}</label>
                        <span id="field.name" class="span-readonly">
                            {{ $_formatMeasurementFieldValue(field) }}
                        </span>
                    </div>
                    <!-- Date field & Category field & Numeric field -->
                    <div
                        class="div-readonly"
                        v-if="
                            field.type === fieldTypeConst.DATE ||
                            field.type === fieldTypeConst.CATEGORY ||
                            field.type === fieldTypeConst.NUMERIC ||
                            field.type === fieldTypeConst.NUMERICWITHDECIMALS
                        "
                    >
                        <label for="field.name">{{ field.alias }}</label>
                        <span id="field.name" class="span-readonly">{{
                            field.displayValue
                        }}</span>
                    </div>
                </div>
            </template>
            <div v-if="creationDate" class="form-group pl-3">
                <!-- Creation date -->
                <div class="div-readonly">
                    <label for="creationDate.name">{{ $t('timeStamp') }}</label>
                    <span id="creationDate.name" class="span-readonly">{{
                        creationDate.displayValue
                    }}</span>
                </div>
            </div>
            <!-- Affiliated feedback message -->
            <div class="web-feedback-affiliated">
                <span v-if="objectData.affiliatedFeedbackCount === 1"
                    >Er is één melder die dit ook vindt.</span
                >
                <span v-if="objectData.affiliatedFeedbackCount > 1"
                    >Er zijn {{ objectData.affiliatedFeedbackCount }} melders
                    die dit ook vinden.</span
                >
            </div>
        </div>
    </div>
</template>

<script>
    import { FIELD_TYPE } from '../../../constants';

    export default {
        props: { objectData: { type: Object, required: true } },

        data() {
            return { fieldTypeConst: FIELD_TYPE };
        },

        computed: {
            displayFields() {
                return Object.values(this.objectData);
            },
            location() {
                return this.displayFields.find(
                    (field) =>
                        !field.personalData &&
                        field.name === 'adres' &&
                        field.type === FIELD_TYPE.GENERIC
                );
            },
            notification() {
                return this.displayFields.filter(
                    (field) =>
                        (!field.personalData &&
                            field.value &&
                            field.value.toString().length > 0) ||
                        field.name === 'meldingsnummer'
                );
            },
            creationDate() {
                return this.displayFields.find(
                    (field) =>
                        !field.personalData &&
                        field.name === 'aanmaakdatum' &&
                        field.type === FIELD_TYPE.GENERIC
                );
            }
        },

        methods: {
            $_getFullAddress(value) {
                const address1 = value.split(',')[0];
                const address2 = value.split(',')[1];
                let fullAdress = null;

                // Only add part 1 if it has a value
                if (address1 && address1.trim().length > 0) {
                    fullAdress = address1;
                }

                // Only add part 2 if it has a value
                if (address2 && address2.trim().length > 0) {
                    fullAdress = `${fullAdress}, ${address2}`;
                }
                return fullAdress;
            },

            /**
             * Get domain description on the basis of field.value
             * @param  {object} field the field object
             * @return {string} domain description
             */
            $_getDomainDescription(field) {
                let domainValue = '';

                if (field.domain) {
                    const foundDomain = field.domain.keyvalues.find((kv) => {
                        return kv.key === field.value;
                    });
                    if (foundDomain) {
                        domainValue = foundDomain.value;
                    }
                }
                return domainValue;
            },
            $_formatMeasurementFieldValue(field) {
                if (field.name === 'length') {
                    return `${field.displayValue} m`;
                } else if (field.name === 'area') {
                    return `${field.displayValue} m\xB2`;
                }
            }
        }
    };
</script>

<style scoped>
label {
    font-weight: normal;
}

.web-feedback-subtitle {
    padding-top: 20px;
}
.web-feedback-subtitle:first-of-type {
    padding-top: 0px;
}

.web-feedback-affiliated {
    padding: 12px 0px;
}

.readonly-scrollable {
    max-height: 104px;
    overflow-y: auto;
}
</style>
